<template>
    <ModalWrapper v-model="dialog" :max-width="1200">
        <internal-notes
            :specified-service="service"
            :communications="communications"
            :communications-loading="communicationsLoading"
            :order-id="orderId"
            @get-communications="getCommunications"
        />
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_SERVICE_NOTES_MODAL} from '@/utils/event-bus'
    import InternalNotes from '@/components/account/internalNotes/InternalNotes.vue'

    @Component({
        components: {InternalNotes},
    })
    export class ServiceNotesModal extends Vue {
        @Prop({required: true}) orderId
        @Prop({required: true}) communications
        @Prop({required: true}) communicationsLoading

        @Emit()
        getCommunications() {}

        dialog = false
        service = null

        mounted() {
            EventBus.$on(SHOW_SERVICE_NOTES_MODAL, this.show)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_SERVICE_NOTES_MODAL, this.show)
        }

        show(service) {
            this.service = service
            this.dialog = true
        }
    }

    export default ServiceNotesModal
</script>
